import {
  forEach as _forEach,
  get as _get,
  isFunction as _isFunction,
  trimStart as _trimStart,
} from 'lodash-es';
import $ from 'jquery';
import * as queryString from 'query-string';

const query = queryString.parse(window.location.search);

function getElementOffset(el) {
  const winScrollPos = getWindowScrollPos();
  const elRect = el.getBoundingClientRect();
  return {
    top: (elRect.top + winScrollPos.top),
    left: (elRect.left + winScrollPos.left),
  };
}

function getFormData(formEl) {
  const dataSerialized = $(formEl).serializeArray();
  const data = new FormData();
  _forEach(dataSerialized, (field) => {
    data.append(field.name, field.value);
  });
  return data;
}

function getHash() {
  return _trimStart(window.location.hash, '#');
}

function getQueryVar(key) {
  return _get(query, key);
}

function getWindowScrollPos() {
  return {
    left: (window.pageXOffset || document.documentElement.scrollLeft),
    top: (window.pageYOffset || document.documentElement.scrollTop),
  };
}

function loadImageThen(src, cb) {
  const image = new Image();
  if (_isFunction(cb)) image.onload = cb;
  image.src = src;
}

function scrollSmoothly(target) {
  $('html,body')
    .stop()
    .animate({
      scrollTop: $(target).offset().top
    }, 'slow');
}

function convertCssDurationToMilliseconds(time) {
  if (/ms$/.test(time)) {
    return parseFloat(time);
  }

  return parseFloat(time) * 1000;
}

function getChildElementAlignment(wrapper) {
  const wrapperContentJustify = window.getComputedStyle(wrapper).getPropertyValue('justify-content');

  switch (wrapperContentJustify) {
    case "flex-end":
      return "right";

    case "normal":
    case "flex-start":
      return "left";

    default:
      return null;
  }
}

export default {
  getElementOffset,
  getFormData,
  getHash,
  getQueryVar,
  getWindowScrollPos,
  loadImageThen,
  scrollSmoothly,
  convertCssDurationToMilliseconds,
  getChildElementAlignment,
};
